import { Component, Input, OnInit } from '@angular/core';
import { WELLHEAD_SCHEME_SECTIONS } from 'src/app/handover-constants';
import { Handover } from 'src/app/interfaces/handover';
import {
  WellheadScheme,
  WellheadSchemeSection,
} from 'src/app/interfaces/wellhead';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { NotificationService } from 'src/app/services/notification.service';
import { PendingChanges } from '../../shared/pending-changes.class';

@Component({
  selector: 'app-handover-detail-wellhead-scheme',
  templateUrl: './handover-detail-wellhead-scheme.component.html',
  styleUrls: ['./handover-detail-wellhead-scheme.component.scss'],
  standalone: false,
})
export class HandoverDetailWellheadSchemeComponent
  extends PendingChanges
  implements OnInit
{
  @Input() handover: Handover | undefined;
  @Input() readOnlyContent!: boolean;

  sections: WellheadSchemeSection[] = WELLHEAD_SCHEME_SECTIONS;
  schemes: WellheadScheme[] = [];
  originalSchemes: WellheadScheme[] = [];
  isLoading = false;
  isDisabled = true;

  constructor(
    public handoverService: HandoverService,
    public dialogService: DialogService,
    public notificationService: NotificationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getWellheadSchemes();
  }

  getWellheadSchemes(): void {
    if (this.handover?.handoverId == undefined) {
      return;
    }
    this.isLoading = true;
    this.handoverService
      .getWellheadSchemes(this.handover.handoverId)
      .subscribe((schemes: WellheadScheme[]) => {
        this.schemes = schemes ?? [];
        this.setOriginalValues();
        this.isLoading = false;
      });
  }

  setOriginalValues(): void {
    this.originalSchemes = this.schemes.map((scheme) =>
      Object.assign({}, scheme)
    );
    this.isDisabled = true;
    this.emitPendingChanges(false);
  }

  addScheme(): void {
    this.schemes.push({});
    this.enableSaveButton();
  }

  removeScheme(index: number): void {
    this.schemes.splice(index, 1);
    this.enableSaveButton();
  }

  enableSaveButton(): void {
    this.isDisabled = !this.thereAreChanges();
    this.emitPendingChanges(!this.isDisabled);
  }

  thereAreChanges(): boolean {
    if (this.schemes.length != this.originalSchemes.length) {
      return true;
    }
    for (let index = 0; index < this.schemes.length; index++) {
      const original = this.originalSchemes[index];
      if (
        this.schemes[index].sectionId != original?.sectionId ||
        this.schemes[index].workingPressure != original?.workingPressure ||
        this.schemes[index].testDate != original?.testDate
      ) {
        return true;
      }
    }
    return false;
  }

  save(): void {
    if (this.handover?.handoverId == undefined) {
      return;
    }
    const dialogRef = this.dialogService.openConfirmDialog(
      'Esquema de Cabezal',
      '¿Desea guardar los cambios realizados en Esquema de Cabezal?'
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.handoverService
          .saveWellheadSchemes(this.handover!.handoverId!, this.schemes)
          .subscribe((savedSchemes: WellheadScheme[]) => {
            if (savedSchemes) {
              this.notificationService.notify(
                'Los cambios en Esquema de Cabezal se han guardado con éxito.',
                true
              );
              this.setOriginalValues();
            } else {
              this.notificationService.notify(
                'Ocurrió un error al grabar los cambios en Esquema de Cabezal.',
                false
              );
            }
          });
      }
    });
  }
}
